import Button from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { useLazyInitiateCSVFilesGenerationQuery } from '@/store/sat/satApi';
import { Dispatch, SetStateAction } from 'react';

type InitiateDownloadProps = {
  testId: string | undefined;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

type ApiError = {
  data: { error: { message: string } };
};

const InitiateDownload = ({ testId, setOpen }: InitiateDownloadProps) => {
  const [initiateDownload, { isLoading }] =
    useLazyInitiateCSVFilesGenerationQuery();
  const { toast } = useToast();
  const handleDownload = async () => {
    const response = await initiateDownload(testId || '');

    if (response.isSuccess) {
      toast({
        description:
          'CSV files generation initiated, please check after sometime...'
      });
      setOpen(false);
    }
    if (response.isError) {
      const error = response.error as ApiError;
      toast({
        title: 'Error!!',
        description: error?.data?.error?.message || 'Something went wrong!!',
        variant: 'destructive'
      });
    }
  };
  return (
    <Button
      className="text-white h-[50px] w-[290px] bg-[#0A3690] font-semibold"
      onClick={handleDownload}
      disabled={isLoading}
      variant={'default'}>
      Initiate response files generation
    </Button>
  );
};

export default InitiateDownload;
